import { post, fetch, patch, put, postJson, fetch_blob } from '../../http'
export default {
  //下载文件
  downloadFile(params) {
    return fetch_blob('/file/minio/downloadFile', params)
  },
}
